import React from 'react'
import ContentHeader from '../../containers/ContentHeader/ContentHeaderNew'
import PageTab from '../../components/PageTab'
import PageTabs from '../../components/PageTabs'
import EcgLoader from '../../containers/EcgLoader'
import {
  SETTINGS_PAGE_TABS,
  TABLE_HEADER_HEIGHT,
  SETTINGS_REDESIGN_HEADER_HEIGHT,
  BOTTOM_PADDING,
  getPermissionOptions,
  CUSTOM_TRIGGER_DEFAULT,
  ALL_RECORDINGS_TRIGGER_OPTION,
  TRIAGE_OPTION,
  PRIMARY_TRIGGER_TYPES,
  TRIGGER_FREQUENCY_TYPES,
  getPrimaryTriggerOption,
  CUSTOM_TRIGGER_OPTION,
  TRIGGER_TYPES,
  ROUTES,
} from '../../constants'
import { TeamInvitesTable, CrpTeamMembersTable as TeamMembersTable } from '../../containers/Tables'
import styles from './Settings.css'
import { needToBustCache } from '../../store/appReducer'
import { CrpNewMemberForm as NewMemberForm, UpdatePasswordForm, InboxSettingsForm, CrpTeamSettingsForm } from '../../containers/Forms'
import {
  checkTKFeatureEnabled,
  checkCRPFeatureEnabled,
  checkRpmFeatureEnabled,
  checkServiceProviderFeatureEnabled,
  checkIdtfServiceProviderFeatureEnabled,
} from 'configs'
import TkandCrpUpdatePasswordForm from '../../containers/Forms/TkandCrpUpdatePasswordForm'
import CustomModal from 'views/components/Modal/CustomModal'
import WarningIcon from 'static/images/Warning.png'
import NewUpdatePasswordForm from '../../containers/Forms/NewUpdatePasswordForm'

const TEAM_INVITES_ROW_HEIGHT = 50
class TkAndCrpSettings extends React.Component {
  state = {
    innerHeight: 0,
  }
  UNSAFE_componentWillMount() {
    const {
      dataLastUpdated,
      getSettingsData,
      getTeamMemberFileData,
    } = this.props
    getSettingsData(needToBustCache(dataLastUpdated))
    getTeamMemberFileData(needToBustCache(dataLastUpdated))
    window.addEventListener('resize', this.handleResize)
    this.setState({
      innerHeight: window.innerHeight,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }


  handleResize = () => {
    this.setState({
      innerHeight: window.innerHeight,
    })
  }

  render() {
    const {
      dataIsFetching,
      dataLastUpdated,
      handleOnRefreshClick,
      refreshClicked,
      bulkActionComplete,
      bulkActionIsFetching,
      getSettingsData,
      selectedIndex,
      selectedPageTab,
      selectedPopover,
      handleOnTabClick,
      handleOnInviteSubmit,
      handleOnFilterButtonClick,
      handleOnSelectionClick,
      teamInvitesIds,
      selectedTeamInvites,
      selectedTeamInvitesEmail,
      updateSelectedTeamInvites,
      teamInvitesSortBy,
      teamInvitesSortDirection,
      handleOnTeamInvitesFilterChange,
      handleOnTeamInvitesSortClick,
      handleOnTeamInvitesBulkAction,
      teamMembersIds,
      teamMembersSortBy,
      teamMembersSortDirection,
      selectedTeamMembers,
      selectedTeamMembersId,
      selectedTeamMembersEmail,
      selectedTeamMembersAdminPermissionId,
      selectedTeamMembersPhysicianPermissionId,
      updateSelectedTeamMembers,
      handleOnTeamMembersFilterChange,
      handleOnTeamMembersSortClick,
      handleOnTeamMemberRowClick,
      me,
      teamInvites: teamInvitesDataSource,
      physicians: physiciansDataSource,
      teamTriggers: teamTriggersDataSource,
      pwError,
      pwErrorMsg,
      pwIsFetching,
      validationTests,
      handleUpdatePasswordChange,
      handleAppointmentNotificationsChange,
      handleOnEditTeamMemberSubmit,
      getAppointmentNotificationsSettings,
      submitUpdatePassword,
      handleInboxSettingsForm,
      inboxSettingsFormData,
      inboxSettingsFormPristine,
      handleOnEditTeamMember,
      getTeamMemberFileData,
      memberOnChangeInfo,
      memberInfo,
      inviteMemberFormValues,
      isModalOpen,
      handleModalOpen,
      handleModalClosed,
      handleSavedChanges,
      handleUnsavedChanges,
      isUnsaved,
      handleLeaveWithoutSave,
      successAlert,
      successInviteClosed,
      emailAlert,
      emailTakenClosed,
      reserveData,
    } = this.props
    const {
      innerHeight,
    } = this.state

    const height = innerHeight - SETTINGS_REDESIGN_HEADER_HEIGHT
    const width = 1180 - (20 * 2)

    let teamInvites = []
    if (me.data && me.data.teams[0].invites && teamInvitesDataSource.data) {
      teamInvites = teamInvitesIds.map(id => teamInvitesDataSource.data.byId[id])
    }

    let teamMembers = []
    if (physiciansDataSource.data && !refreshClicked) {
      teamMembers = teamMembersIds.map(id => physiciansDataSource.data.byId[id])
    }
    // THIS IS THE SAME LOGIC COPIED FROM THE PATIENT FILE
    let inboxSettingsInitialValues = {
      custom: {
        ...CUSTOM_TRIGGER_DEFAULT,
      },
      ekgReviewWhichRecordings: ALL_RECORDINGS_TRIGGER_OPTION,
      ekgReviewWhereRecordings: TRIAGE_OPTION,
    }

    const getFormInboxPresets = (triggersById, typeToIdLookup, presets) => {
      const newPresets = {
        ...presets,
      }
      const whichPrimaryTriggerType = Object.keys(PRIMARY_TRIGGER_TYPES).find(triggerType => {
        const id = typeToIdLookup[triggerType]
        return triggersById[id].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS
      })

      if (whichPrimaryTriggerType) {
        const id = typeToIdLookup[whichPrimaryTriggerType]
        const triggerData = triggersById[id]
        newPresets.ekgReviewWhichRecordings = getPrimaryTriggerOption(whichPrimaryTriggerType, triggerData)
      } else {
        newPresets.ekgReviewWhichRecordings = CUSTOM_TRIGGER_OPTION
        const possibleAFibResultId = typeToIdLookup[TRIGGER_TYPES.POSSIBLE_AFIB_DETECTION]
        if (triggersById[possibleAFibResultId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.possibleAFibResultCheckmark = true
        }
        const possibleAFibResultWithHrId = typeToIdLookup[TRIGGER_TYPES.HEART_RATE_OVER_X_AND_AFIB]
        if (triggersById[possibleAFibResultWithHrId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.possibleAFibResultWithHrCheckmark = true
          newPresets.custom.possibleAFibResultWithHr = parseInt(triggersById[possibleAFibResultWithHrId].value, 10)
        }
        const allUnclassifiedId = typeToIdLookup[TRIGGER_TYPES.ALL_UNCLASSIFIED]
        if (triggersById[allUnclassifiedId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.unclassifiedResultCheckmark = true
        }
        const heartRateUnderId = typeToIdLookup[TRIGGER_TYPES.HEART_RATE_UNDER_X]
        if (triggersById[heartRateUnderId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.heartRateUnderCheckmark = true
          newPresets.custom.heartRateUnder = parseInt(triggersById[heartRateUnderId].value, 10)
        }
        const heartRateOverId = typeToIdLookup[TRIGGER_TYPES.HEART_RATE_OVER_X]
        if (triggersById[heartRateOverId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.heartRateOverCheckmark = true
          newPresets.custom.heartRateOver = parseInt(triggersById[heartRateOverId].value, 10)
        }
        const bradycardiaId = typeToIdLookup[TRIGGER_TYPES.BRADYCARDIA]
        if (triggersById[bradycardiaId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.bradycardia = true
        }
        const tachycardiaId = typeToIdLookup[TRIGGER_TYPES.TACHYCARDIA]
        if (triggersById[tachycardiaId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.tachycardia = true
        }
        const sinusRhythmWithPVCsId = typeToIdLookup[TRIGGER_TYPES.SINUS_RHYTHM_PVC]
        if (triggersById[sinusRhythmWithPVCsId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.sinusRhythmWithPVCs = true
        }
        const sinusRhythmWithSVEsId = typeToIdLookup[TRIGGER_TYPES.SINUS_RHYTHM_SVE]
        if (triggersById[sinusRhythmWithSVEsId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.sinusRhythmWithSVEs = true
        }
        const sinusRhythmWithWideQRSId = typeToIdLookup[TRIGGER_TYPES.SINUS_RHYTHM_WIDE_QRS]
        if (triggersById[sinusRhythmWithWideQRSId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.sinusRhythmWithWideQRS = true
        }
      }
      return newPresets
    }

    if (teamTriggersDataSource.data) {
      inboxSettingsInitialValues = {
        ...inboxSettingsInitialValues,
        ...getFormInboxPresets(teamTriggersDataSource.data.byId, teamTriggersDataSource.data.typeToIdLookup, inboxSettingsInitialValues),
      }
    }

    let teamInvitesTableHeight = teamInvites.length > 0
      ? (TEAM_INVITES_ROW_HEIGHT * teamInvites.length)
      : (TEAM_INVITES_ROW_HEIGHT * 5)
    teamInvitesTableHeight += TABLE_HEADER_HEIGHT

    let isAdmin = false
    if (me.data) {
      const { isAdmin: adminPermission } = me.data.profile.permissions
      isAdmin = adminPermission
    }

    let physician
    let initialValues
    if (memberInfo.data) {
      physician = memberInfo.data
      initialValues = physician
    }

    const TKFeatureEnabled = checkTKFeatureEnabled(me)
    const CRPFeatureEnabled = checkCRPFeatureEnabled(me)
    const RPMFeatureEnabled = checkRpmFeatureEnabled(me)
    const KPSPFeatureEnabled = checkServiceProviderFeatureEnabled(me)
    const IDTFServiceProviderFeatureEnabled = checkIdtfServiceProviderFeatureEnabled(me)

    return (
      <div data-page="settings" className={styles.settings}>
        <ContentHeader
          renderNewUI
          showBreadcrumbNavigation
          isLoading={dataIsFetching}
          lastUpdated={dataLastUpdated}
          handleOnRefreshClick={handleOnRefreshClick}
          hasTabs={isAdmin}
          showAddPatient={false}
          enableBackButton
          text="Settings"
          me={me}
        />
        <PageTabs useNewStyles>
          {
            (CRPFeatureEnabled || TKFeatureEnabled) && me.data && me.data.profile.permissions.isAdmin ?
              <PageTab
                isActive={selectedPageTab === SETTINGS_PAGE_TABS.UPDATE_PASSWORD}
                handleOnClick={() => handleOnTabClick(SETTINGS_PAGE_TABS.UPDATE_PASSWORD)}
                label={(CRPFeatureEnabled || TKFeatureEnabled) ? 'My Info' : 'Update Password'}
              /> : ''
          }

          {isAdmin
            && (
              <React.Fragment>
                {(CRPFeatureEnabled || TKFeatureEnabled) && (
                  <PageTab
                    isActive={selectedPageTab === SETTINGS_PAGE_TABS.TEAM_SETTINGS}
                    handleOnClick={() => handleOnTabClick(SETTINGS_PAGE_TABS.TEAM_SETTINGS)}
                    label="Team Settings"
                    useNewStyles
                  />
                )}
                <PageTab
                  isActive={selectedPageTab === SETTINGS_PAGE_TABS.TEAM_MEMBERS}
                  handleOnClick={() => handleOnTabClick(SETTINGS_PAGE_TABS.TEAM_MEMBERS)}
                  label="Team Members"
                  useNewStyles
                />
                <PageTab
                  isActive={selectedPageTab === SETTINGS_PAGE_TABS.INVITE_TEAM_MEMBER}
                  handleOnClick={() => handleOnTabClick(SETTINGS_PAGE_TABS.INVITE_TEAM_MEMBER)}
                  label="Invite Member"
                  useNewStyles
                />
                {!(CRPFeatureEnabled || TKFeatureEnabled || KPSPFeatureEnabled) && (
                  <PageTab
                    isActive={selectedPageTab === SETTINGS_PAGE_TABS.INBOX_SETTINGS}
                    handleOnClick={() => handleOnTabClick(SETTINGS_PAGE_TABS.INBOX_SETTINGS)}
                    label="Inbox Settings"
                    useNewStyles
                  />
                )}
              </React.Fragment>
            )}
        </PageTabs>

        {selectedPageTab === SETTINGS_PAGE_TABS.UPDATE_PASSWORD &&
          <div
            className={styles.formWrapper}
            style={{
              height,
            }}
          >
            <div className={styles.formTop}>
              <TkandCrpUpdatePasswordForm
                handleInputChange={handleUpdatePasswordChange}
                handleNotificationChange={handleAppointmentNotificationsChange}
                onSubmit={handleOnEditTeamMemberSubmit}
                isSubmitting={pwIsFetching}
                showTKFeatureEnabled={TKFeatureEnabled}
                showCRPFeatureEnabled={CRPFeatureEnabled}
                showRPMFeatureEnabled={RPMFeatureEnabled}
                pwError={pwError}
                pwErrorMsg={pwErrorMsg}
                validationTests={validationTests}
                me={me}
                getAppointmentNotificationsSettings={getAppointmentNotificationsSettings}
                getMemberInfo={getTeamMemberFileData}
                initialValues={initialValues}
                memberOnChangeInfo={memberOnChangeInfo}
                isModalOpen={isModalOpen}
                handleModalOpen={handleModalOpen}
                onInfoSubmit={handleOnEditTeamMemberSubmit}
                handleModalClosed={handleModalClosed}
                handleSavedChanges={handleSavedChanges}
                handleUnsavedChanges={handleUnsavedChanges}
                isUnsaved={isUnsaved}
                handleLeaveWithoutSave={handleLeaveWithoutSave}
              />
              <NewUpdatePasswordForm
                handleInputChange={handleUpdatePasswordChange}
                handleNotificationChange={handleAppointmentNotificationsChange}
                onSubmit={submitUpdatePassword}
                isSubmitting={pwIsFetching}
                pwError={pwError}
                pwErrorMsg={pwErrorMsg}
                validationTests={validationTests}
                me={me}
                getAppointmentNotificationsSettings={getAppointmentNotificationsSettings}
                getMemberInfo={getTeamMemberFileData}
                onInfoSubmit={handleOnEditTeamMemberSubmit}
                memberOnChangeInfo={memberOnChangeInfo}
              />
            </div>
          </div>
        }

        {selectedPageTab === SETTINGS_PAGE_TABS.INVITE_TEAM_MEMBER
          && ((dataIsFetching && (!me.data || (me.data && !me.data.teams[0].invites))) || refreshClicked) && (
          <div
            className={styles.contentWrapper}
            style={{
              height,
            }}
          >
            <EcgLoader />
          </div>
        )}

        {selectedPageTab === SETTINGS_PAGE_TABS.INVITE_TEAM_MEMBER
          && !((dataIsFetching && (!me.data || (me.data && !me.data.teams[0].invites))) || refreshClicked) && (
          <div
            className={styles.formWrapper}
            style={{
              height,
            }}
          >
            <div className={styles.formTop}>
              <NewMemberForm
                onSubmit={handleOnInviteSubmit}
                isSubmitting={dataIsFetching}
                showTKFeatureEnabled={TKFeatureEnabled}
                showCRPFeatureEnabled={CRPFeatureEnabled}
                showRPMFeatureEnabled={RPMFeatureEnabled}
                inviteMemberFormValues={inviteMemberFormValues}
                successAlert={successAlert}
                successInviteClosed={successInviteClosed}
                emailAlert={emailAlert}
                emailTakenClosed={emailTakenClosed}
                reserveData={reserveData}
              />
            </div>
            <div className={styles.formTop}>
              <h2 className={styles.formTitle}>Pending Invites</h2>
              <div
                className={styles.revokeSection}
                style={{
                  height: teamInvitesTableHeight,
                }}
              >
                <TeamInvitesTable
                  data={teamInvites}
                  showRowSelection={true}
                  selected={selectedTeamInvites}
                  onSelectionClick={handleOnSelectionClick}
                  height={height}
                  width={width - (30 * 2)}
                  sortBy={teamInvitesSortBy}
                  sortDirection={teamInvitesSortDirection}
                  rowHeight={TEAM_INVITES_ROW_HEIGHT}
                  filterEmail={selectedTeamInvitesEmail}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  handleOnFilterChange={handleOnTeamInvitesFilterChange}
                  handleOnSortClick={handleOnTeamInvitesSortClick}
                  handleOnOutsidePopoverClick={() => handleOnFilterButtonClick(null)}
                  handleOnBulkAction={handleOnTeamInvitesBulkAction}
                  handleOnBulkActionClearSelection={() => handleOnSelectionClick({})}
                  handleOnPopoverKeyUp={e => {
                    const enterKeyCode = 13
                    if (typeof handleOnFilterButtonClick === 'function' && e.keyCode === enterKeyCode) {
                      handleOnFilterButtonClick(null)
                    }
                  }}
                  bulkActionComplete={bulkActionComplete}
                  bulkActionIsFetching={bulkActionIsFetching}
                  selectedPopover={selectedPopover}
                  selectedEmail={selectedTeamInvitesEmail}
                  me={me}
                />
              </div>
            </div>
          </div>
        )
        }

        {selectedPageTab === SETTINGS_PAGE_TABS.TEAM_MEMBERS &&
          <div
            style={{
              height,
            }}
          >
            <TeamMembersTable
              enableLoader={teamMembersIds.length === 0 || refreshClicked}
              showLoader={dataIsFetching}
              data={teamMembers}
              showRowSelection={false}
              selected={selectedTeamMembers}
              onSelectionClick={updateSelectedTeamMembers}
              height={height}
              width={width}
              onRowClick={handleOnTeamMemberRowClick}
              selectedIndex={selectedIndex}
              sortBy={teamMembersSortBy}
              sortDirection={teamMembersSortDirection}
              filterName={selectedTeamMembersId}
              filterEmail={selectedTeamMembersEmail}
              filterAdminPermission={selectedTeamMembersAdminPermissionId}
              filterPhysicianPermission={selectedTeamMembersPhysicianPermissionId}
              handleOnFilterButtonClick={handleOnFilterButtonClick}
              handleOnFilterChange={handleOnTeamMembersFilterChange}
              handleOnSortClick={handleOnTeamMembersSortClick}
              handleOnOutsidePopoverClick={() => handleOnFilterButtonClick(null)}
              // handleOnBulkAction={handleOnTeamMembersBulkAction}
              handleOnPopoverKeyUp={e => {
                const enterKeyCode = 13
                if (typeof handleOnFilterButtonClick === 'function' && e.keyCode === enterKeyCode) {
                  handleOnFilterButtonClick(null)
                }
              }}
              selectedPopover={selectedPopover}
              physicians={physiciansDataSource}
              selectedId={selectedTeamMembersId}
              selectedEmail={selectedTeamMembersEmail}
              permissionOptions={getPermissionOptions().slice(1)}
              selectedAdminPermissionId={selectedTeamMembersAdminPermissionId}
              selectedPhysicianPermissionId={selectedTeamMembersPhysicianPermissionId}
              handleOnClickTeamMeamber={handleOnTabClick}
              handleOnEditTeamMember={handleOnEditTeamMember}
              showTKFeatureEnabled={TKFeatureEnabled}
              me={me}
            />
          </div>
        }

        {selectedPageTab === SETTINGS_PAGE_TABS.INBOX_SETTINGS &&
          <div
            className={styles.formWrapper}
            style={{
              height,
            }}
          >
            <div className={styles.formTop}>
              <h2 className={styles.formTitle}>Team Inbox Settings</h2>
              <InboxSettingsForm
                onSubmit={handleInboxSettingsForm}
                triggers={teamTriggersDataSource}
                inboxSettingsFormData={inboxSettingsFormData}
                initialValues={inboxSettingsInitialValues}
                isSubmitting={!inboxSettingsFormPristine && (teamTriggersDataSource.isFetching || dataIsFetching)}
              />
            </div>
          </div>
        }
        {selectedPageTab === SETTINGS_PAGE_TABS.TEAM_SETTINGS &&
          <div
            className={styles.formWrapper}
            style={{
              height,
            }}
          >
            <div className={styles.formTop}>
              <CrpTeamSettingsForm/>
            </div>
          </div>
        }
      </div>
    )
  }
}

export default TkAndCrpSettings



// WEBPACK FOOTER //
// ./src/legacy/pages/Settings/TkAndCrpSettings.jsx